import {Col, Row} from "antd";
import React from "react";
import {HeaderTop} from "@/components/Header/HeaderTop";
import {HeaderBottom} from "@/components/Header/HeaderBottom";
import {HeaderMiddle} from "@/components/Header/HeaderMiddle";

export const AppHeader = () => (
        <Row>
            <Col flex="auto">
                <HeaderTop/>
                <HeaderMiddle/>
                <HeaderBottom/>
            </Col>
        </Row>
    )